module.exports = __webpack_public_path__ + "static/media/IMG_3099.9dcb2d28.JPG";